<kendo-window [resizable]="false" (close)="onClose(null)" [class.jobs-billing]="cardModalService.isJobsBillingDashboard()">
    @if(cardPositionDataInColumn.showLeftArrow) {
    <button class="wk-cm__navigation-button noselect wk-cm__navigation-button--previous" (click)="handleArrowClick('previous')">
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
    </button>
    }

    <div class="wk-cm__container">
        @if (!this.cardModalService.isJobsBillingDashboard()) {
        <wk-west-panel />
        }
        <div class="wk-cm__content">
            <wk-north-panel />
            <form
                class="wk-cm__form"
                [class.jobs-billing]="cardModalService.isJobsBillingDashboard()"
                [formGroup]="cardModalService.cardModalFormGroup()"
            >
                <wk-card-panel />
            </form>
            <wk-south-panel />
        </div>
    </div>

    @if(cardPositionDataInColumn.showRightArrow) {
    <button class="wk-cm__navigation-button noselect wk-cm__navigation-button--next" (click)="handleArrowClick('next')">
        <i class="fa fa-chevron-right" aria-hidden="true"></i>
    </button>
    }
</kendo-window>

<div kendoDialogContainer></div>
